/**
 * Mutable experience API base URL and request headers used by ExperienceService and re-engagement tracking.
 * experienceApi is updated when global config loads (see ExperienceService.updateGlobalConfig).
 */
export const experienceApiEndpoint = {
  experienceApiConfig: process.env.VITE_EXPERIENCE_API_CONFIG || process.env.VITE_EXPERIENCE_API || '',
  experienceApi: process.env.VITE_EXPERIENCE_API || '',
  daGatewayApi: process.env.VITE_DA_GATEWAY_API || '',
  servicesApi: process.env.VITE_SERVICES_BASE_URL?.replace(/\/+$/, '') || '',
  daGatewayDevelopmentOrigin: process.env.VITE_DA_GATEWAY_DEVELOPMENT_ORIGIN?.replace(/['"]+/g, '').trim() || undefined,
  mocked: process.env.VITE_MOCKED_ORIGIN?.replace(/['"]+/g, '').trim() || undefined,
  apiKey: process.env.VITE_API_KEY,
};
